import React, { MouseEventHandler } from 'react';
import { DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { Button, ButtonToolbar } from 'reactstrap';
import CloseableDialogComponent from './CloseableDialogComponent';
import { t } from '../../i18n/t';

interface DiscardIssueDialogProps {
  isOpen: boolean;
  handleClose: MouseEventHandler;
  handleDiscardIssue: MouseEventHandler;
}

function DiscardIssueDialog(props: DiscardIssueDialogProps) {

  const {
    isOpen,
    handleClose,
    handleDiscardIssue,
  } = props;

  const renderDialog = () => (
    <CloseableDialogComponent
      isOpen={isOpen}
      handleClose={handleClose}
      maxWidth="sm"
      title={t('discard-issue-dialog#title')}
    >
      <DialogContent>
        <DialogContentText>
          <div className="title m-0 text-left">
            {t('discard-issue-dialog#content')}
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions className="popup-footer justify-content-end p-0">
        <ButtonToolbar>
          <Button
            id="button-warning-cancel"
            title={t('continue-editing')}
            color="link"
            onClick={handleClose}
          >
            {t('continue-editing')}
          </Button>
          <Button
            id="button-warning-ok"
            title={t('discard-issue')}
            color="primary"
            onClick={handleDiscardIssue}
          >
            {t('discard-issue')}
          </Button>
        </ButtonToolbar>
      </DialogActions>
    </CloseableDialogComponent>
  );

  return renderDialog();
}

export default DiscardIssueDialog;
